/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import "./WidgetPanel.css";
import {
    CloseMenuIcon,
    DriversMenuIcon,
    ProjectMenuIcon,
    SentimentMenuIcon,
    TextBoxMenuIcon,
    VolumeMenuIcon,
    WhatsNewMenuIcon,
} from "../../../icons";

import classNames from "classnames";
import { NewWidgetNames } from "../../../constants/WidgetNames";
import {
    getSentimentStatus,
    SENTIMENT_STATUS,
} from "../../../utils/sentimentStatus";
import { useGetProjectByIdQuery } from "../../../store/api/lumi/projects";
import { useParams } from "react-router-dom";
import { WidgetSubMenuItem } from "./WidgetSubMenuItem";

export const WidgetPanel = ({
    isSidebarOpen,
    setIsSidebarOpen,
    metaDataQu,
}) => {
    const [selectedMenuIndex, setSelectedMenuIndex] = React.useState();
    const [hoverMenuIndex, setHoverMenuIndex] = React.useState();
    const [subMenuItems, setSubMenuItems] = React.useState([]);

    const { id } = useParams();
    const { data: project } = useGetProjectByIdQuery(id);
    const sentimentStatus = getSentimentStatus(project);
    const overTimeDisabled = !metaDataQu?.metaDataDate[0]?.name;
    const driversDisabled = !metaDataQu?.metaDataDrivers[0]?.name;
    const sentimentDisabled = sentimentStatus !== SENTIMENT_STATUS.READY;
    const disabledWithoutStringsType =
        !metaDataQu?.metaDataWithStringType[0]?.name;

    const MENU_ITEMS = [
        {
            icon: <TextBoxMenuIcon />,
            label: NewWidgetNames.TEXT_BOX,
            items: [
                {
                    label: NewWidgetNames.TEXT_WIDGET,
                    gridData: {
                        showFilter: false,
                        disable_header: true,
                        title: NewWidgetNames.TEXT_WIDGET,
                        minH:4,
                        minW: 4,
                        h: 8,
                        w: 4,
                    },
                },
            ],
        },
        {
            icon: <ProjectMenuIcon />,
            label: NewWidgetNames.PROJECT,
            items: [
                {
                    label: NewWidgetNames.DOCUMENTS,
                    gridData: {
                        showFilter: true,
                        title: NewWidgetNames.DOCUMENTS,
                        without_header: true,
                        h: 5,
                        w: 3,
                        minH: 5,
                        minW: 3,
                    },
                },
                {
                    label: NewWidgetNames.AVERAGE_SCORE,
                    gridData: {
                        showFilter: true,
                        title: NewWidgetNames.AVERAGE_SCORE,
                        without_header: true,
                        h: 5,
                        w: 3,
                        minH: 5,
                        minW: 3,
                    },
                    disable: driversDisabled,
                },
                {
                    label: NewWidgetNames.AVERAGE_SCORE_OVERTIME,
                    gridData: {
                        showFilter: true,
                        title: NewWidgetNames.AVERAGE_SCORE_OVERTIME,
                        lineChart: true,
                        minH: 10,
                        minW: 4,
                    },
                    disable: overTimeDisabled || driversDisabled,
                },
                {
                    label: NewWidgetNames.NUMBER_METADATA_BREAKDOWN,
                    gridData: {
                        title: NewWidgetNames.NUMBER_METADATA_BREAKDOWN,
                        showFilter: true,
                        without_header: true,
                        h: 7,
                        w: 5,
                        minH: 6,
                        minW: 4,
                    },
                    disable: overTimeDisabled || driversDisabled,
                    driversDisabled,
                    overTimeDisabled,
                },
                {
                    label: NewWidgetNames.NPS_BREAKDOWN,
                    gridData: {
                        title: NewWidgetNames.NPS_BREAKDOWN,
                        showFilter: true,
                        without_header: true,
                        h: 7,
                        w: 5,
                        minH: 7,
                        minW: 4,
                    },
                    disable: overTimeDisabled || driversDisabled,
                    driversDisabled,
                    overTimeDisabled,
                },
                {
                    label: NewWidgetNames.NPS_SCORE,
                    gridData: {
                        title: NewWidgetNames.NPS_SCORE,
                        showFilter: true,
                        without_header: true,
                        h: 5,
                        w: 3,
                        minH: 5,
                        minW: 3,
                    },
                    disable: overTimeDisabled || driversDisabled,
                    driversDisabled,
                    overTimeDisabled,
                },
                {
                    label: NewWidgetNames.NPS_SCORE_OVERTIME,
                    gridData: {
                        title: NewWidgetNames.NPS_SCORE_OVERTIME,
                        showFilter: true,
                        without_header: true,
                        h: 10,
                        w: 5,
                        minH: 10,
                        minW: 5,
                        lineChart: true,
                    },
                    disable: overTimeDisabled || driversDisabled,
                    driversDisabled,
                    overTimeDisabled,
                },
                {
                    label: NewWidgetNames.QUALITATIVE_METADATA_BREAKDOWN,
                    gridData: {
                        showFilter: true,
                        without_header: true,
                        title: NewWidgetNames.QUALITATIVE_METADATA_BREAKDOWN,
                        h: 7,
                        w: 5,
                        minH: 6,
                        minW: 4,
                    },
                    disable: disabledWithoutStringsType,
                },
                {
                    label: NewWidgetNames.METADATA_SHARE_OF_VOICE_OVER_TIME,
                    gridData: {
                        showFilter: true,
                        lineChart: true,
                        without_header: true,
                        title: NewWidgetNames.METADATA_SHARE_OF_VOICE_OVER_TIME,
                        minH: 10,
                        minW: 4,
                    },
                    disable: overTimeDisabled || driversDisabled,
                },
                {
                    label: NewWidgetNames.METADATA_CONCEPT_VOLUME,
                    gridData: {
                        showFilter: true,
                        without_header: true,
                        title: NewWidgetNames.METADATA_CONCEPT_VOLUME,
                        h: 10,
                        w: 5,
                        minH: 6,
                        minW: 4,
                    },
                    disable: disabledWithoutStringsType,
                },
                {
                    label: NewWidgetNames.METADATA_SENTIMENT_BREAKDOWN,
                    gridData: {
                        showFilter: true,
                        without_header: true,
                        title: NewWidgetNames.METADATA_SENTIMENT_BREAKDOWN,
                        h: 10,
                        w: 5,
                        minH: 6,
                        minW: 4,
                    },
                    disable: disabledWithoutStringsType,
                },
                {
                    label: NewWidgetNames.METADATA_DRIVERS_BREAKDOWN,
                    gridData: {
                        showFilter: true,
                        without_header: true,
                        title: NewWidgetNames.METADATA_DRIVERS_BREAKDOWN,
                        h: 10,
                        w: 5,
                        minH: 6,
                        minW: 4,
                    },
                    disable: disabledWithoutStringsType,
                },
            ],
        },
        {
            icon: <VolumeMenuIcon />,
            label: NewWidgetNames.VOLUME,
            items: [
                {
                    label: NewWidgetNames.VOLUME,
                    gridData: {
                        title: NewWidgetNames.VOLUME,
                        showFilter: true,
                        without_header: true,
                        minH: 10,
                        minW: 4,
                    },
                },
                {
                    label: NewWidgetNames.LARGEST_CONCEPT_MOVEMENT,
                    gridData: {
                        title: NewWidgetNames.LARGEST_CONCEPT_MOVEMENT,
                        showFilter: true,
                        without_header: true,
                        minH: 12,
                        minW: 10,
                        h: 12,
                        w: 10,
                    },
                    disable: overTimeDisabled,
                },
                {
                    label: NewWidgetNames.VOLUME_OVER_TIME,
                    gridData: {
                        title: NewWidgetNames.VOLUME_OVER_TIME,
                        showFilter: true,
                        minH: 10,
                        minW: 4,
                        lineChart: true,
                    },
                    disable: overTimeDisabled,
                },
                {
                    label: NewWidgetNames.SHARE_OF_VOICE_OVER_TIME,
                    gridData: {
                        title: NewWidgetNames.SHARE_OF_VOICE_OVER_TIME,
                        showFilter: true,
                        lineChart: true,
                        minH: 10,
                        minW: 4,
                    },
                    disable: overTimeDisabled,
                },
                {
                    label: NewWidgetNames.SHARE_OF_VOICE_OVER_TIME_BUBBLE,
                    gridData: {
                        title: NewWidgetNames.SHARE_OF_VOICE_OVER_TIME_BUBBLE,
                        showFilter: true,
                        without_header: true,
                        minH: 12,
                        minW: 6,
                    },
                    disable: overTimeDisabled,
                },
            ],
        },
        {
            icon: <SentimentMenuIcon />,
            label: NewWidgetNames.SENTIMENT,
            items: [
                {
                    label: NewWidgetNames.LARGEST_NET_SENTIMENT_MOVEMENT,
                    gridData: {
                        title: NewWidgetNames.LARGEST_NET_SENTIMENT_MOVEMENT,
                        showFilter: true,
                        without_header: true,
                        minH: 12,
                        minW: 6,
                    },
                    sentimentStatus,
                    disable: overTimeDisabled || sentimentDisabled,
                },
                {
                    label: NewWidgetNames.SENTIMENT_OVER_TIME_LINE,
                    gridData: {
                        title: NewWidgetNames.SENTIMENT_OVER_TIME_LINE,
                        showFilter: true,
                        lineChart: true,
                        minH: 10,
                        minW: 4,
                    },
                    sentimentStatus,
                    disable: overTimeDisabled || sentimentDisabled,
                },
                {
                    label: NewWidgetNames.OVERALL_SENTIMENT,
                    gridData: {
                        title: NewWidgetNames.OVERALL_SENTIMENT,
                        showFilter: true,
                        h: 7,
                        w: 5,
                        minH: 6,
                        minW: 4,
                    },
                    sentimentStatus,
                    disable: sentimentDisabled,
                },
                {
                    label: NewWidgetNames.SENTIMENT_SHARE,
                    gridData: {
                        title: NewWidgetNames.SENTIMENT_SHARE,
                        showFilter: true,
                        sentimentFilter: true,
                        without_header: true,
                        h: 14,
                        minH: 13,
                        minW: 6,
                    },
                    sentimentStatus,
                    disable: sentimentDisabled,
                },
            ],
        },
        {
            icon: <DriversMenuIcon />,
            label: NewWidgetNames.DRIVERS,
            items: [
                {
                    label: NewWidgetNames.DRIVERS,
                    gridData: {
                        title: NewWidgetNames.DRIVERS,
                        showFilter: true,
                        minH: 10,
                        minW: 4,
                    },
                    disable: driversDisabled,
                    driversDisabled,
                },
                {
                    label: NewWidgetNames.DRIVERS_OVER_TIME,
                    gridData: {
                        title: NewWidgetNames.DRIVERS_OVER_TIME,
                        showFilter: true,
                        lineChart: true,
                        minH: 10,
                        minW: 4,
                    },
                    disable: overTimeDisabled || driversDisabled,
                    overTimeDisabled,
                    driversDisabled,
                },
                {
                    label: NewWidgetNames.LARGEST_DRIVERS_MOVEMENT,
                    gridData: {
                        title: NewWidgetNames.LARGEST_DRIVERS_MOVEMENT,
                        showFilter: true,
                        minH: 10,
                        minW: 4,
                    },
                    disable: overTimeDisabled || driversDisabled,
                    overTimeDisabled,
                    driversDisabled,
                },
                {
                    label: NewWidgetNames.DRIVERS_DIFFERENCE_FROM_AVERAGE,
                    gridData: {
                        title: NewWidgetNames.DRIVERS_DIFFERENCE_FROM_AVERAGE,
                        showFilter: true,
                        lineChart: true,
                        minH: 10,
                        minW: 4,
                    },
                    disable: overTimeDisabled || driversDisabled,
                    overTimeDisabled,
                    driversDisabled,
                },
                {
                    label: NewWidgetNames.IMPACT_SCORE,
                    gridData: {
                        title: NewWidgetNames.IMPACT_SCORE,
                        showFilter: true,
                        minH: 9,
                        minW: 4,
                    },
                    disable: overTimeDisabled || driversDisabled,
                    overTimeDisabled,
                    driversDisabled,
                },
            ],
        },
        {
            icon: <WhatsNewMenuIcon />,
            label: NewWidgetNames.WHATS_NEW,
            items: [
                {
                    label: NewWidgetNames.OUTLIER_PERCENTAGE,
                    gridData: {
                        showFilter: true,
                        title: NewWidgetNames.OUTLIER_PERCENTAGE,
                        minH: 10,
                        minW: 5,
                    },
                    disable: overTimeDisabled,
                },
            ],
        },
    ];

    const subMenuIndex =
        hoverMenuIndex !== undefined ? hoverMenuIndex : selectedMenuIndex;
    return (
        <div className="widget-main">
            <div className="widget-panel">
                <div className="widget-panel-content">
                    {MENU_ITEMS.map((item, index) => (
                        <div className="widget-panel-item">
                            <div
                                className="widget-menu"
                                onClick={() => {
                                    setSelectedMenuIndex(index);
                                    if (!isSidebarOpen) {
                                        setIsSidebarOpen(true);
                                    }
                                }}
                                onMouseEnter={() => {
                                    setHoverMenuIndex(index);
                                    setSubMenuItems(item.items);
                                }}
                                onMouseLeave={() => {
                                    setHoverMenuIndex(undefined);
                                    if (selectedMenuIndex !== undefined) {
                                        setSubMenuItems(
                                            MENU_ITEMS[selectedMenuIndex].items
                                        );
                                    } else {
                                        setSubMenuItems([]);
                                    }
                                }}
                            >
                                <div
                                    className={classNames({
                                        icon: true,
                                        active: selectedMenuIndex === index,
                                    })}
                                >
                                    {item.icon}
                                </div>
                                <div className="widget-label">
                                    <h5>{item.label}</h5>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            {subMenuIndex !== undefined && (
                <div
                    className={classNames({
                        "expanded-section": true,
                        active: subMenuIndex !== undefined,
                    })}
                >
                    <div className="header">
                        <span>{MENU_ITEMS[subMenuIndex].label}</span>
                        <a
                            className="close"
                            onClick={() => {
                                setIsSidebarOpen(false);
                                setSelectedMenuIndex(undefined);
                            }}
                        >
                            <CloseMenuIcon />
                        </a>
                    </div>
                    <ul>
                        {subMenuItems.map((item, index) => (
                            <WidgetSubMenuItem
                                key={index}
                                text={item?.label}
                                gridData={item?.gridData}
                                disabled={item?.disable}
                                sentimentStatus={item?.sentimentStatus}
                                overTimeDisabled={item?.overTimeDisabled}
                                driversDisabled={item?.driversDisabled}
                            />
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};
